export default __webpack_public_path__ + "static/media/polygon-selected.178517a0.svg";